import { render, staticRenderFns } from "./SupportingFileUploader.vue?vue&type=template&id=8b5721c0&scoped=true&"
import script from "./SupportingFileUploader.vue?vue&type=script&lang=js&"
export * from "./SupportingFileUploader.vue?vue&type=script&lang=js&"
import style0 from "./SupportingFileUploader.vue?vue&type=style&index=0&id=8b5721c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5721c0",
  null
  
)

export default component.exports